import * as go from 'gojs';
import { getImageJawCrusherCJ } from 'unitData/Crushers/CrusherJawCJ/getImageJawCrusherCJ';
import { getImageBinding, getIOPort, makeNode } from '../../utils';
import type { JawCrusherNodeData } from 'gojs/types';

const JawCrusherCJTemplate = makeNode(
  getImageBinding('', (data: JawCrusherNodeData) =>
    getImageJawCrusherCJ(data.modelName, data.showCustomModel),
  ),
  [getIOPort(go.Spot.Bottom, 'output'), getIOPort(go.Spot.Top, 'input')],
  { imageMargin: 0 },
);

export default JawCrusherCJTemplate;
